import React, {useState, useRef, useEffect} from 'react'

import ReactCrop, {
    centerCrop,
    makeAspectCrop,
    Crop,
    PixelCrop,
    convertToPixelCrop,
} from 'react-image-crop'
import setCanvasPreview from './Utils/setCanvasPreview'
import { useDebounceEffect } from './Utils/useDevounceEffect'
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalContent,
    ModalHeader,
    useDisclosure,
    Button,
    Image
} from "@nextui-org/react";

import 'react-image-crop/dist/ReactCrop.css'

function centerAspectCrop( mediaWidth, mediaHeight, aspect) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: '%',
                width: 90,
            },
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    )
}

export default function ImageCropper({setImage, name}) {
    const [imgSrc, setImgSrc] = useState('')
    const previewCanvasRef = useRef(null)
    const imgRef = useRef(null)
    const [crop, setCrop] = useState()
    const [completedCrop, setCompletedCrop] = useState()
    const [scale, setScale] = useState(1)
    const [rotate, setRotate] = useState(0)
    const [aspect, setAspect] = useState(1 / 1)
    const {isOpen, onOpen, onClose} = useDisclosure();

    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            setCrop(undefined) // Makes crop preview update between images.
            const reader = new FileReader()
            reader.addEventListener('load', () =>
                setImgSrc(reader.result?.toString() || ''),
            )
            reader.readAsDataURL(e.target.files[0])
        }
    }

    useEffect(() => {
        if(!!imgSrc)
            onOpen()
    }, [imgSrc]);

    function onImageLoad(e) {
        if (aspect) {
            const { width, height } = e.currentTarget
            setCrop(centerAspectCrop(width, height, aspect))
        }
    }

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                // We use canvasPreview as it's much faster than imgPreview.
                setCanvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                    scale,
                    rotate,
                )
            }
        },
        100,
        [completedCrop, scale, rotate],
    )

    async function SetImageFunction() {
        const image = imgRef.current
        const previewCanvas = previewCanvasRef.current;

        if (!image || !completedCrop || !previewCanvas) {
            throw new Error('Crop image does not exist');
        }
        const scaleX = image.naturalWidth / image.width
        const scaleY = image.naturalHeight / image.height

        const offscreen = new OffscreenCanvas(
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
        )
        const ctx = offscreen.getContext('2d')
        if (!ctx) {
            throw new Error('No 2d context')
        }

        ctx.drawImage(
            previewCanvas,
            0,
            0,
            previewCanvas.width,
            previewCanvas.height,
            0,
            0,
            offscreen.width,
            offscreen.height,
        )

        const blob = await offscreen.convertToBlob({
            type: 'image/png',
        })

        const file = new File([blob], `${name}.png`, { type: 'image/png' })

        setImage(file)
    }


    function OnConfirmCrop(e) {
        SetImageFunction();
        onClose();

    }

    return (
        <>
            <div className="flex flex-row gap-1 text-center">
                <label htmlFor="imagen">Imagen</label>
                <input id="imagen" type="file" accept="image/*" onChange={onSelectFile} disabled={name === undefined}/>
            </div>
            <Modal
                size="lg"
                isOpen={isOpen}
                onClose={onClose}
                isDismissable={false}
                backdrop="blur"
                hideCloseButton
            >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">Recortar imagen</ModalHeader>
                            <ModalBody>
                                {!!imgSrc && (
                                    <ReactCrop
                                        crop={crop}
                                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                                        onComplete={(c) => setCompletedCrop(c)}
                                        aspect={aspect}
                                        minHeight={100}
                                    >
                                        <img
                                            ref={imgRef}
                                            alt="Crop me"
                                            src={imgSrc}
                                            style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                                            onLoad={onImageLoad}
                                        />
                                    </ReactCrop>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onClick={OnConfirmCrop}>
                                    Cortar
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            {!!completedCrop && (
                <>
                    <div>
                        <canvas
                            ref={previewCanvasRef}
                            style={{
                                border: '1px solid black',
                                objectFit: 'contain',
                               maxHeight: '200px',
                            }}
                        />
                    </div>

                </>
            )}
        </>
    )
}
